/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Grok_OpenInputs */

const en_mcp_grok_open = /** @type {(inputs: Mcp_Grok_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to grok.com/connectors.`)
};

const es_mcp_grok_open = /** @type {(inputs: Mcp_Grok_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ve a grok.com/connectors.`)
};

/**
* | output |
* | --- |
* | "Go to grok.com/connectors." |
*
* @param {Mcp_Grok_OpenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_grok_open = /** @type {((inputs?: Mcp_Grok_OpenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Grok_OpenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_grok_open(inputs)
	return en_mcp_grok_open(inputs)
});